import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const parentsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'parents'] as const,
    id: <V extends QueryKeyParam>(parentId: V) =>
      createQueryKey({
        all: [...keys, 'parents', parentId] as const,
      }),
  });

export { parentsKeys };
